import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "../Icon";
import { ButtonProps } from "../Button/types";
import { variants } from "../Button/buttonVariants";
import Loading from "../Button/Loading";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      variant = "primary",
      size,
      width,
      loading,
      faIcon,
      faIconLeft,
      faIconRight,
      type,
      href,
      target,
      rel,
      ...rest
    },
    ref,
  ) => {
    const buttonClassName = twMerge(
      variants({ variant, size, width, className }),
    );
    const commonProps = {
      className: buttonClassName,
      ...rest,
    };

    const content = (
      <>
        {loading ? <Loading variant={variant} /> : null}
        {faIconLeft ? (
          <Icon
            className="flex items-center justify-center -ml-2 mr-3 w-4 h-4"
            faIcon={faIconLeft}
          />
        ) : null}
        <span
          className={clsx("transition", {
            "opacity-0": loading,
            "opacity-100": !loading,
            "mr-auto": !faIcon,
          })}
        >
          {children}

          {faIcon ? (
            <Icon
              className="flex items-center justify-center w-4 h-4"
              faIcon={faIcon}
            />
          ) : null}
        </span>

        {faIconRight ? (
          <Icon
            className="flex items-center justify-center ml-3 -mr-2 w-4 h-4"
            faIcon={faIconRight}
          />
        ) : null}
      </>
    );

    if (type === "link") {
      return (
        <a href={href} className={buttonClassName} target={target} rel={rel}>
          {content}
        </a>
      );
    }

    return (
      <button ref={ref} type={type} {...commonProps}>
        {content}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
